export default __webpack_public_path__ + "static/media/slider5.3d9c0e25.jpeg";